import * as models from './model';

export interface Customer {
    companyName: string;
    bpCode: string;
    partnerId: string;
}
